export default (originalBody: string) => {
  let body = originalBody;

  // Remove `<style></style>` tags
  body = body.replace(/<style([\s\S]+?)<\/style>/g, '');

  // Remove `<script></script>` tags
  body = body.replace(/<script([\s\S]+?)<\/script>/g, '');

  // Remove ids
  body = body.replace(/(\s)(id="[\w|\-|_|\d]+")([\s|>])/g, '$1 $3');

  // Experimental: Add &nbsp; in empty divs
  body = body.replace(/(<div>)(\s)(<\/div>)/g, '$1&nbsp;$3');

  // Experimental: Replace fonts
  body = body.replace(/font-family:\s?"([\w\s]+)"/g, 'Mark Pro');

  // Replace double spaces with a single
  body = body.replace(/\s\s/g, ' ');

  return body;
};
